<template>
  <div class="reset-page">
    <div class="reset-header">
      <div>
        <img src="../../assets/image/header-logo.png" alt="广播影视人才交流中心" />
        <span class="col-line"></span>
        <span>重置密码</span>
      </div>
    </div>
    <div class="reset-steps">
      <div>
        <div class="icon-box" @click="setSteps(1)">
          <img src="../../assets/image/reset-steps1-icon.png" alt="账号填写" />
          <span>账号填写</span>
        </div>
        <div :class="steps1LineClass"></div>
        <div class="icon-box" @click="setSteps(2)">
          <img :src="steps2Icon" alt="身份验证" />
          <span :class="steps2Color">身份验证</span>
        </div>
        <div :class="steps2LineClass"></div>
        <div class="icon-box" @click="setSteps(3)">
          <img :src="steps3Icon" alt="设置新密码" />
          <span :class="steps3Color">设置新密码</span>
        </div>
        <div :class="steps3LineClass"></div>
        <div class="icon-box" @click="setSteps(4)">
          <img :src="steps4Icon" alt="完成" />
          <span :class="steps4Color">完成</span>
        </div>
      </div>
    </div>
    <div class="reset-content">
      <div>
        <Steps1 v-if="steps === 1" :toNext="toNextSteps" />
        <Steps2 v-if="steps === 2" :toNext="toNextSteps" />
        <Steps3 v-if="steps === 3" :toNext="toNextSteps" />
        <Steps4 v-if="steps === 4" :toNext="toNextSteps" />
      </div>
    </div>
  </div>
</template>
<script>
import Steps1 from './components/steps1.vue'
import Steps2 from './components/steps2.vue'
import Steps3 from './components/steps3.vue'
import Steps4 from './components/steps4.vue'
export default {
  name: 'ResetPassword',
  components: { Steps1, Steps2, Steps3, Steps4 },
  data() {
    return {
      steps: 1
    }
  },
  computed: {
    steps2Icon: function () {
      return require(`../../assets/image/reset-steps2-icon${
        this.steps >= 2 ? 2 : 1
      }.png`)
    },
    steps3Icon: function () {
      return require(`../../assets/image/reset-steps3-icon${
        this.steps >= 3 ? 2 : 1
      }.png`)
    },
    steps4Icon: function () {
      return require(`../../assets/image/reset-steps4-icon${
        this.steps >= 4 ? 2 : 1
      }.png`)
    },
    steps1LineClass: function () {
      return this.steps < 2 ? 'steps-half' : 'steps-all'
    },
    steps2LineClass: function () {
      return this.steps < 2
        ? 'steps-none'
        : this.steps < 3
        ? 'steps-half'
        : 'steps-all'
    },
    steps3LineClass: function () {
      return this.steps === 4
        ? 'steps-all'
        : this.steps === 3
        ? 'steps-half'
        : 'steps-none'
    },
    steps2Color: function () {
      return `steps-font-color-${this.steps >= 2 ? 'light' : 'default'}`
    },
    steps3Color: function () {
      return `steps-font-color-${this.steps >= 3 ? 'light' : 'default'}`
    },
    steps4Color: function () {
      return `steps-font-color-${this.steps >= 4 ? 'light' : 'default'}`
    }
  },
  methods: {
    toNextSteps() {
      this.steps += 1
    },
    setSteps(ind) {
      this.steps = ind
    }
  }
}
</script>
<style lang='scss' scoped>
.steps-half {
  width: 252px;
  height: 4px;
  // border-bottom: 4px solid;
  // border-image: linear-gradient(0deg, #a4cfff, #f2f2f2) 10 10;
  background: linear-gradient(90deg, #a4cfff 0%, #f2f2f2 100%);
}
.steps-none {
  width: 252px;
  height: 4px;
  background: #c6c6c6;
  // border-bottom: 4px solid #c6c6c6;
}
.steps-all {
  width: 252px;
  height: 4px;
  // border-bottom: 4px solid;
  // border-image: linear-gradient(0deg, #a4cfff) 10 10;
  background: linear-gradient(90deg, #a4cfff 0%);
}
.steps-font-color-default {
  color: #333333;
}
.steps-font-color-light {
  color: #045ec4;
}
.reset-page {
  .reset-header {
    height: 83px;
    background: linear-gradient(90deg, #0f59be 0%, #4a6eef 100%);
    > div {
      width: 1300px;
      height: 100%;
      margin: 0 auto;
      line-height: 83px;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #fffcfc;
      > img {
        width: 164px;
        height: auto;
        vertical-align: middle;
        margin-right: 24px;
      }
      .col-line {
        width: 0;
        display: inline-block;
        height: 34px;
        border-left: 1px solid #f2f2f2;
        margin-right: 24px;
        vertical-align: middle;
      }
    }
  }
  .reset-steps {
    height: 102px;
    background: #ffffff;
    box-shadow: 0px 0px 1px 0px rgba(51, 51, 51, 0.44);
    > div {
      width: 1300px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .icon-box {
        width: 100px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #045ec4;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        > img {
          margin-bottom: 10px;
        }
      }
    }
  }
  .reset-content {
    background: #eef3ff;
    padding: 65px 0;
    > div {
      width: 1300px;
      margin: 0 auto;
    }
  }
}
</style>
